import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { LightComponent } from './light.component';
import { LightLocationModel } from './lights-store/lights.actions';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'era-lights-ui',
  templateUrl: './lights.component.html',
  imports: [LightComponent],
})
export class LightsComponent {
  readonly lights = input.required<LightLocationModel[]>();
}
